@let notificationsValue = notifications();
@let notificationsCount = notificationsValue.length;
@let notificationsLoadingValue = notificationsLoading();
@let unreadNotificationsCountValue = unreadNotificationsCount();
@let hasAccessToNotificationsModifyValue = hasAccessToNotificationsModify();

<div class="notifications-toggle-panel">
  <div class="notifications-toggle-panel__toggle" (click)="togglePanel()">
    <i class="notifications-toggle-panel__notification-icon fa-regular fa-bell"></i>
    <span class="notifications-toggle-panel__toggle-text">{{ 'header.notifications' | translate }}</span>
    <div class="notifications-toggle-panel__toggle-right">
      @if (unreadNotificationsCountValue > 0) {
        <span class="notifications-toggle-panel__count-badge">{{ unreadNotificationsCountValue }}</span>
      }
      @if (notificationsCount === 0 && !notificationsLoadingValue && unreadNotificationsCountValue === 0) {
        <span class="notifications-toggle-panel__empty">{{ 'notifications.empty.title' | translate }}</span>
      }

      @if (notificationsLoadingValue) {
        <div class="notifications-toggle-panel__spinner">
          <kds-spinner />
        </div>
      } @else if (notificationsCount > 0 || unreadNotificationsCountValue > 0) {
        <i
          class="notifications-toggle-panel__toggle-icon fa-regular fa-chevron-down"
          [class.notifications-toggle-panel__toggle-icon--expanded]="!isCollapsed()"
        ></i>
      }
    </div>
  </div>

  @if (!isCollapsed() && notificationsCount) {
    <div class="notifications-toggle-panel__content" [@toggleContentFadeIn]="true" [@toggleContentFadeOut]="true">
      @if (unreadNotificationsCountValue > 0) {
        <div
          class="notifications-toggle-panel__action-button"
          [class.notifications-toggle-panel__action-button--disabled]="!hasAccessToNotificationsModifyValue"
          [attr.aria-disabled]="!hasAccessToNotificationsModifyValue || null"
          [kdsTooltip]="'general.missing-permission' | translate"
          [disableTooltip]="hasAccessToNotificationsModifyValue"
          (click)="markAllNotificationsAsViewed()"
        >
          {{ 'notifications.mark-all-as-read' | translate }}
        </div>
      }

      <div class="notifications-toggle-panel__divider"></div>

      @if (notificationsCount) {
        @for (notification of notificationsValue; track notification.id; let last = $last) {
          <div class="notifications-toggle-panel__notification">
            <itc-notification [notification]="notification" [showBorder]="!last" />
          </div>
        }
      }
    </div>
  }
</div>
